module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-menu"
  }, [_c('div', {
    staticClass: "menu-items"
  }, [_c('div', {
    staticClass: "menu-category"
  }, [_vm._v("Site")]), _vm._v(" "), _vm._l((_vm.mySites), function(site, siteId) {
    return _c('div', {
      key: siteId,
      staticClass: "menu-item",
      attrs: {
        "ontouchstart": ""
      },
      on: {
        "click": function($event) {
          _vm.selectSite(siteId)
        }
      }
    }, [_c('div', {
      staticClass: "menu-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "menu-info"
    }, [_c('div', {
      staticClass: "main-info"
    }, [_vm._v(_vm._s(site.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub-info"
    }, [_vm._v(_vm._s(site.address))])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb1fdd8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompMenu.vue
// module id = 280
// module chunks = 1